export const CATEGORY_LABELS = Object.freeze({
    desk: 'Desk',
    chair: 'Chair',
    table: 'Table',
    storage: 'Filing and storage',
    shelving: 'Shelving',
    cubicle: 'Cubicle and partition',
    lab_equipment: 'Lab equipment',
    electronics: 'Electronics',
    whiteboard: 'Whiteboard',
    other: 'Other',
});

export const CONDITION_LABELS = Object.freeze({
    like_new: 'Like new',
    good: 'Good',
    fair: 'Fair',
    needs_repair: 'Needs repair',
});

// Mirrors STATUSES in server/src/api/listing/listing.constants.js, in the same
// order. The admin Listings tab sends the whole comma-separated key set as the
// `status` query value and the route validates it against its own enum, so a
// key added or renamed here alone answers 400 on every read that tab makes.
// A status is added on both sides or on neither.
export const STATUS_LABELS = Object.freeze({
    available: 'Available',
    requested: 'Requested',
    claimed: 'Claimed',
    completed: 'Completed',
    expired: 'Expired',
    removed: 'Removed',
});

export const STATUS_VARIANTS = Object.freeze({
    available: 'success',
    requested: 'warning',
    claimed: 'info',
    completed: 'secondary',
    expired: 'dark',
    removed: 'danger',
});

export const OPEN_STATUSES = Object.freeze(['available', 'requested']);

// Mirrors the `building` ceiling in the server's listQuerySchema, which is
// the stored field's own maximum. Over it the route answers 400, which the
// filter surfaces as a connection problem, so the box cannot hold a term that
// would be refused.
export const BUILDING_MAX_LENGTH = 120;

// Mirrors server/src/api/listing/listing.constants.js. The server enforces
// both; checking them here turns a rejected upload into an inline message
// instead of a round trip that loses the member's file selection.
export const PHOTO_LIMIT = 5;
export const PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const PHOTO_ACCEPT = 'image/jpeg,image/png,image/webp';
